/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_ButtonInputs */

const vi_order_lot_trace_button = /** @type {(inputs: Order_Lot_Trace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy xuất nguồn gốc`)
};

/**

* @param {Order_Lot_Trace_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_button = /** @type {((inputs?: Order_Lot_Trace_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_button(inputs)
});